import './ListerHeader.scss';

import React from 'react';
import { useSelector } from 'react-redux';

import {
	useIsSmallAndAbove,
	useIsXMediumAndAbove,
} from '../../hooks/mediaQueries';
import { isBrowserIE11 } from '../../utilities/lister-utilities';
import { Breakpoint } from '../../utilities/ui-utilities';
import TopBanner from '../Banner/TopBanner/TopBanner';
import ErrorBoundary from '../ErrorBoundary';
import SortBy from '../ListerControls/SortBy/SortBy';
import ListerTitle from './ListerTitle';
import ProductsPerPage from './ProductsPerPage';
import TrendingBrands from './TrendingBrands/TrendingBrands';
import ViewControls from './ViewControls';

const ListerHeader = () => {
	const { isDealsPage } = useSelector((state) => state);

	const isSmallAndAbove = useIsSmallAndAbove();
	const isXMediumAndAbove = useIsXMediumAndAbove();

	const { CustomCategoriesEnabled } = useSelector(
		(state) => state.experimentSwitches
	);

	return (
		<header data-tag-section="lister header">
			<ListerTitle />

			{!isDealsPage && (
				<ErrorBoundary>
					<TopBanner />
				</ErrorBoundary>
			)}

			{!isBrowserIE11() && <TrendingBrands />}

			{((isSmallAndAbove && !CustomCategoriesEnabled) ||
				(isXMediumAndAbove && CustomCategoriesEnabled)) && (
				<div className="pt-2" data-testid="responsive-header">
					<div className="flex">
						{isDealsPage && (
							<div className="flex-auto">
								<ViewControls />
							</div>
						)}
						<div className="flex items-center">
							<SortBy />
						</div>
						<div className="flex-auto flex justify-end items-center">
							<ProductsPerPage />
						</div>
					</div>
				</div>
			)}
		</header>
	);
};

export default ListerHeader;
